import { render, staticRenderFns } from "./ClientDemographicsSocial.vue?vue&type=template&id=7b9de662"
import script from "./ClientDemographicsSocial.vue?vue&type=script&lang=js"
export * from "./ClientDemographicsSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports